import React from 'react';

import classNames from 'classnames';

import * as addressFormats from 'helpers/formatters/address_formats';
import { clickAsLink } from 'helpers/link_helpers';

import type { Property } from 'bundles/crm/properties/types';

interface Props {
  href?: string;
  property: Property;
  onClick?: (event: React.MouseEvent) => void;
}

export default function CrmPropertyCardContent({ href, property, onClick }: Props) {
  if (!onClick && href) {
    onClick = event => clickAsLink(window, href, event);
  }

  return (
    <div className="d-flex flex-column justify-content-md-between gap-3 gap-md-2 h-100">
      <div>
        <h4 className={classNames('mt-0 mb-2', { clickable: !!onClick })} onClick={onClick}>
          <b>{property.displayName || property.address}</b>
        </h4>
        {!!property.displayName && property.displayName !== property.address &&
          <span className="mb-2 text-muted">{property.address}</span>
        }
        <div className="mb-2 text-muted">{addressFormats.twoLine(property)[1]}</div>
      </div>
      <div className="text-muted text-xs">
        {[property.propertyTypeLabel, property.buildingSizeLabel, property.dealStatusLabel].filter(Boolean).join(' • ')}
      </div>
    </div>
  );
}
